import { render, staticRenderFns } from "./salesteamlead_vue.vue?vue&type=template&id=1b123434&scoped=true&"
import script from "./salesteamlead_vue.vue?vue&type=script&lang=js&"
export * from "./salesteamlead_vue.vue?vue&type=script&lang=js&"
import style0 from "./salesteamlead_vue.vue?vue&type=style&index=0&id=1b123434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b123434",
  null
  
)

export default component.exports